<template>
    <div :class="`sticky-banner ds-bg-${color}-100`">
        <div class="sticky-banner__content">
            <div class="sticky-banner__left">
                <div class="sticky-banner__title">
                    <AkIcon size="md" :symbol="banner.icon" :class="`ds-text-${color}-700`" />
                    <AkParagraph v-if="banner.title" :class="`ds-text-${color}-700 sticky-banner__title-text`">
                        {{ banner.title }}
                    </AkParagraph>
                </div>
                <AkParagraph v-if="banner.description" class="sticky-banner__description">
                    {{ banner.description }}
                </AkParagraph>
            </div>
            <AkButton v-if="banner.buttonText" size="lg" :symbol="accepted ? 'x' : ''"
                :symbolPosition="accepted ? right : ''" :link="accepted" color="primary" class="sticky-banner__button"
                @click="(event) => $emit('clicked', event)">
                {{ banner.buttonText }}
            </AkButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import { AkParagraph, AkButton, AkIcon, IconName } from '@ankorstore/design-system';
import { computed } from 'vue';
const props = defineProps<{
    banner: {
        title?: string;
        description?: string;
        buttonText?: string;
        icon?: IconName;
        color?: string;
        status?: string;
    };
}>();
const accepted = computed(() => {
    return props.banner.status === 'approved';
});
const color = computed(() => {
    return props.banner.color;
});
</script>


<style scoped lang="scss">
.sticky-banner {
    @apply ds-w-full ds-py-3 ds-px-6;
    &__content {
        @apply ds-flex ds-flex-wrap ds-justify-between ds-items-center ds-gap-4;
    }
    &__button {
        @apply ds-self-center;
    }
    &__left {
        @apply ds-flex ds-flex-col ds-gap-1 ds-items-start;
    }
    &__title {
        @apply ds-flex ds-items-center ds-gap-2;
    }
    &__title-text {
        @apply ds-text-base ds-font-semibold;
    }
    &__description {
        @apply ds-text-sm;
    }
}
</style>